import * as NavConstants from 'constants/NavConstants';
import {AgentType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {ChatDraftStatus, createChatWithDraftMessage} from 'llm/chat-library/ChatActions';
import {openExistingChat} from 'llm/chat-library/sidepanel/AISidepanelV2GlobalClientState';
import {getChatTypeForNewAgentChat} from 'llm/chat-library/sidepanel/ChatTypeUtil';
import * as SidepanelActions from 'nav/sidepanel/SidepanelActions';
import {CheckEntryDisplayResult} from 'notebook/ai-tools/NotebookAIToolsConstants';

export function formatFixSelectedMessage(selectedResults: ReadonlyArray<CheckEntryDisplayResult>): string {
  const bullets = selectedResults.map((r) => `- ${r.text}`).join('\n');
  return [
    'Please help me address the following Notebook Check findings on this entry. For each item, propose a concrete fix and, where appropriate, make the change directly.',
    '',
    bullets,
  ].join('\n');
}

/**
 * Returns the new chat session ID, or null if the chat session could not be created (e.g. a 402
 * error was suppressed by the chat library).
 */
export async function fixCheckResultsWithAssistant(
  entryId: string,
  selectedResults: ReadonlyArray<CheckEntryDisplayResult>
): Promise<string | null> {
  const message = formatFixSelectedMessage(selectedResults);
  const agentType = AgentType.ASSISTANT;
  const chatType = getChatTypeForNewAgentChat(agentType);

  let chatSessionId: string;
  try {
    const result = await createChatWithDraftMessage(chatType, {
      createChatOptions: {[AgentType.ASSISTANT]: {targetEntryId: entryId}},
      createParams: {contextIds: [entryId]},
      draft: {
        status: ChatDraftStatus.DRAFT,
        message: {text: message, selectedFiles: []},
        settings: {agentType, publicDataEnabled: false},
      },
    });
    chatSessionId = result.chatSessionId;
  } catch (e) {
    if ((e as {__suppress_notification?: boolean}).__suppress_notification) {
      return null;
    }
    throw e;
  }

  openExistingChat(chatSessionId);
  SidepanelActions.openSection(NavConstants.SECTIONS.AI);
  return chatSessionId;
}
